import styleInject from '../../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = "H4.ProductsTitle-module_title__rRehR {\n  margin-bottom: 0px;\n  margin-top: 0px;\n}";
var styles = {"title":"ProductsTitle-module_title__rRehR"};
styleInject(css_248z,{"insertAt":"top"});

export { styles as default };
//# sourceMappingURL=ProductsTitle.module.scss.js.map
